(function () {
  if (window.__whimsieButterflies) return;
  window.__whimsieButterflies = true;

  var COLORS = ['#ffb3d9', '#ffffff', '#ff8fc7', '#ffffff'];

  function svgMarkup(color, size) {
    var h = Math.round(size * 0.75);
    return (
      '<svg class="whimsie-butterfly__svg" viewBox="0 0 40 30" width="' + size + '" height="' + h +
      '" xmlns="http://www.w3.org/2000/svg">' +
      '<g class="whimsie-butterfly__wings">' +
      '<path d="M20 15 C14 2,2 2,2 12 C2 20,12 20,20 15 Z" fill="' + color + '"/>' +
      '<path d="M20 15 C26 2,38 2,38 12 C38 20,28 20,20 15 Z" fill="' + color + '"/>' +
      '<path d="M20 15 C15 18,6 22,8 27 C11 29,17 24,20 15 Z" fill="' + color + '" opacity="0.8"/>' +
      '<path d="M20 15 C25 18,34 22,32 27 C29 29,23 24,20 15 Z" fill="' + color + '" opacity="0.8"/>' +
      '</g>' +
      '<line x1="20" y1="8" x2="20" y2="22" stroke="' + color + '" stroke-width="1.5" opacity="0.85"/>' +
      '</svg>'
    );
  }

  function makeButterfly(size) {
    var el = document.createElement('div');
    el.className = 'whimsie-butterfly';
    var color = COLORS[Math.floor(Math.random() * COLORS.length)];
    el.innerHTML = svgMarkup(color, size || Math.round(18 + Math.random() * 16));
    return el;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function spawnAmbient() {
    var el = makeButterfly();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var x0 = Math.random() * vw;
    var y0 = vh + 40;
    var x1 = x0 + (Math.random() * 240 - 120);
    var y1 = -60;
    el.style.setProperty('--wb-x0', x0 + 'px');
    el.style.setProperty('--wb-y0', y0 + 'px');
    el.style.setProperty('--wb-x1', x1 + 'px');
    el.style.setProperty('--wb-y1', y1 + 'px');
    el.style.setProperty('--wb-r0', Math.round(Math.random() * 30 - 15) + 'deg');
    el.style.setProperty('--wb-r1', Math.round(Math.random() * 60 - 30) + 'deg');
    el.classList.add('whimsie-butterfly--ambient');
    el.style.animationDuration = 7 + Math.random() * 6 + 's';
    document.body.appendChild(el);
    el.addEventListener('animationend', function () {
      el.remove();
    });
  }

  function spawnBurst(x, y, count) {
    count = count || 6;
    for (var i = 0; i < count; i++) {
      (function (i) {
        setTimeout(function () {
          var el = makeButterfly(Math.round(16 + Math.random() * 14));
          var angle = (Math.PI * 2 * i) / count + Math.random() * 0.6;
          var dist = 60 + Math.random() * 90;
          var dx = Math.cos(angle) * dist;
          var dy = Math.sin(angle) * dist - 60;
          el.style.left = x + 'px';
          el.style.top = y + 'px';
          el.style.setProperty('--wb-dx', dx + 'px');
          el.style.setProperty('--wb-dy', dy + 'px');
          el.classList.add('whimsie-butterfly--burst');
          document.body.appendChild(el);
          el.addEventListener('animationend', function () {
            el.remove();
          });
        }, i * 45);
      })(i);
    }
  }

  // Expose so other custom sections (camera roll, etc.) can trigger bursts
  window.whimsieSpawnBurst = spawnBurst;

  function startAmbient() {
    if (!document.querySelector('.password-main-content')) return;
    if (prefersReducedMotion()) return;
    spawnAmbient();
    setInterval(spawnAmbient, 1800);
  }

  var lastPoint = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest && e.target.closest('button, a, input[type="submit"]');
      if (el) {
        var r = el.getBoundingClientRect();
        lastPoint = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    },
    true
  );

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var promise = originalFetch.apply(this, arguments);
      if (isCartAddUrl(url) && !prefersReducedMotion()) {
        promise
          .then(function (res) {
            if (res && res.ok) spawnBurst(lastPoint.x, lastPoint.y, 7);
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (prefersReducedMotion()) return;
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      var emailInput = form.querySelector('input[type="email"]');
      var isEmailForm = action.indexOf('/contact') !== -1 || !!emailInput;
      if (isEmailForm) {
        var target = emailInput || form;
        var r = target.getBoundingClientRect();
        spawnBurst(r.left + r.width / 2, r.top + r.height / 2, 8);
      }
    },
    true
  );

  // Product-page continuation: when arriving via a butterfly-burst click from
  // the Whimsie camera roll (?wb=1), keep a few butterflies fluttering over
  // the product image + title for a few seconds, then settle.
  function startProductPageSwarm() {
    var params;
    try {
      params = new URLSearchParams(location.search);
    } catch (err) {
      return;
    }
    if (params.get('wb') !== '1') return;

    params.delete('wb');
    var newSearch = params.toString();
    var newUrl = location.pathname + (newSearch ? '?' + newSearch : '') + location.hash;
    if (window.history && window.history.replaceState) {
      history.replaceState(null, '', newUrl);
    }

    if (prefersReducedMotion()) return;

    function getBox() {
      var img = document.querySelector('main img, .product-media-gallery img, [id*="MainContent"] img');
      var h1 = document.querySelector('main h1, [id*="MainContent"] h1');
      var rects = [];
      if (img) rects.push(img.getBoundingClientRect());
      if (h1) rects.push(h1.getBoundingClientRect());
      if (!rects.length) return null;
      var left = Math.min.apply(
        null,
        rects.map(function (r) {
          return r.left;
        })
      );
      var top = Math.min.apply(
        null,
        rects.map(function (r) {
          return r.top;
        })
      );
      var right = Math.max.apply(
        null,
        rects.map(function (r) {
          return r.right;
        })
      );
      var bottom = Math.max.apply(
        null,
        rects.map(function (r) {
          return r.bottom;
        })
      );
      return { left: left, top: top, width: right - left, height: bottom - top };
    }

    function spawnOverBox() {
      var box = getBox();
      if (!box || box.width <= 0 || box.height <= 0) return;
      var el = makeButterfly(Math.round(16 + Math.random() * 14));
      var x = box.left + Math.random() * box.width;
      var y = box.top + Math.random() * box.height;
      el.style.left = x + 'px';
      el.style.top = y + 'px';
      el.style.setProperty('--wb-dx', Math.round(Math.random() * 70 - 35) + 'px');
      el.style.setProperty('--wb-dy', Math.round(Math.random() * 50 - 25) + 'px');
      el.classList.add('whimsie-butterfly--burst');
      document.body.appendChild(el);
      el.addEventListener('animationend', function () {
        el.remove();
      });
    }

    var count = 0;
    spawnOverBox();
    var swarmInterval = setInterval(function () {
      spawnOverBox();
      count++;
      if (count > 12) clearInterval(swarmInterval);
    }, 260);
    setTimeout(function () {
      clearInterval(swarmInterval);
    }, 3400);
  }

  function init() {
    startAmbient();
    startProductPageSwarm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
